/**
 * Agrupamento de endpoints por tipo de operação HTTP (modal Grupos → Disponíveis).
 */

/** POST operacionais (impressão, integração, aprovação…) — separados de POST CRUD. */
const ACTION_POST_HINTS = [
	'print', 'export', 'import', 'upload', 'approve', 'reject', 'cancel', 'close', 'reverse',
	'confer', 'pick', 'unpick', 'send', 'query', 'validate', 'retry', 'flush', 'pull',
	'inutilizar', 'report', 'search-references', 'list-stage', 'list_output', 'move-all',
	'create-invoices', 'create-lots', 'create-archive', 'create-outputs', 'complete',
	'putaway', 'inventory', 'repair', 'dispatch', 'mappings', 'overturn', 'balance-trace',
	'count-report', 'print-report', 'create-pending', 'manual-status', 'collector',
];

export const METHOD_CATEGORY_ORDER = [
	{ id: 'consultas', label: 'Consultas (GET)' },
	{ id: 'insercao', label: 'Inserção (POST)' },
	{ id: 'acoes', label: 'Ações e relatórios (POST)' },
	{ id: 'modificacao', label: 'Modificação (PUT/PATCH)' },
	{ id: 'exclusao', label: 'Exclusão (DELETE)' },
	{ id: 'outros', label: 'Outros' },
];

/**
 * @param {{ method?: string, endpoint?: string }} ep
 * @returns {string} id da categoria (consultas | insercao | acoes | modificacao | exclusao | outros)
 */
export function getEndpointMethodCategory(ep)
{
	const method = String(ep?.method || '').toUpperCase();
	const path = String(ep?.endpoint || '').toLowerCase();
	if (method === 'GET')
		return 'consultas';
	if (method === 'DELETE')
		return 'exclusao';
	if (method === 'PUT' || method === 'PATCH')
		return 'modificacao';
	if (method === 'POST')
	{
		if (ACTION_POST_HINTS.some((hint) => path.includes(hint)))
			return 'acoes';
		return 'insercao';
	}
	return 'outros';
}
